import { DateString } from "client/Components";
import { setTrackingId } from "client/Misc/utils";
import { ReactElement } from "react";
import styles from "./EmailDate.module.less";
import { TimeZone } from "client/DateAndTime/timezones";

export type EmailDateProps = {
	value: string | Date | null;
	timezone: TimeZone;
};

export const EmailDate = (props: EmailDateProps): ReactElement => {
	const {
		value,
		timezone
	} = props;

	return (
		<>
			{value && (
				<div
					{...setTrackingId("date")}
					className={styles.root}
				>
					<DateString
						value={value}
						format="RelativeDayWithTime"
						timezone={timezone}
					/>
				</div>
			)}
		</>
	);
};
EmailDate.displayName = "EmailDate";